const conditionalRowStyles = [];

export default conditionalRowStyles;
